import { render, staticRenderFns } from "./Aplicaciones.vue?vue&type=template&id=10b95961"
import script from "./Aplicaciones.vue?vue&type=script&lang=js"
export * from "./Aplicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports